<template>
  <div>
    <p>{{ msg }}</p>
  </div>
</template>

<script>
export default { props: ["msg"] };
</script>

<style lang="scss" scoped>
div {
  display: flex;
  padding: 7px 0px;
  justify-content: flex-end;
  align-items: flex-start;
  align-self: stretch;
}
p {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
  align-self: stretch;
  // color: $text-color9;
  color: var(--custom-color2);
  // color: #a7610f;

  /* label */
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 13.2px */
}
</style>
